import type { GroupedPrefectureMasterRecord } from "../../../../components/PrefecturesSelector/types/groupedPrefectureMasterRecord";
import type { useI18n } from "hooks/i18n/i18n";

export const getConvertNameForLocale =
  (t: ReturnType<typeof useI18n>["t"]) =>
  (area: GroupedPrefectureMasterRecord) => ({
    ...area,
    // @ts-expect-error 本 hooks のテストで担保してる
    name: t(`common.string.location.areas.${area.name}`),
    prefectures: area.prefectures.map((prefecture) => ({
      ...prefecture,
      // @ts-expect-error 本 hooks のテストで担保してる
      name: t(`common.string.location.prefectures.${prefecture.name}`),
    })),
  });
